"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeepValue = void 0;
const react_1 = require("react");
const deepcopy_1 = __importDefault(require("deepcopy"));
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const useDeepValue = (value) => {
    const valueRef = (0, react_1.useRef)((0, deepcopy_1.default)(value));
    const [currentValue, setCurrentValue] = (0, react_1.useState)(valueRef.current);
    const setValue = (0, react_1.useCallback)((value) => {
        if (!(0, fast_deep_equal_1.default)(value, valueRef.current)) {
            valueRef.current = (0, deepcopy_1.default)(value);
            setCurrentValue((0, deepcopy_1.default)(value));
        }
    }, []);
    (0, react_1.useEffect)(() => {
        setValue(value);
    }, [setValue, value]);
    return (0, react_1.useMemo)(() => {
        return { value: currentValue, setValue };
    }, [currentValue, setValue]);
};
exports.useDeepValue = useDeepValue;
//# sourceMappingURL=useDeepValue.js.map